var exports = {
  "container": "x9bf38834--8e1eb8--container",
  "text-block": "x9bf38834--8e1eb8--text-block",
  "title": "x9bf38834--8e1eb8--title",
  "description": "x9bf38834--8e1eb8--description",
  "list": "x9bf38834--8e1eb8--list",
  "item": "x9bf38834--8e1eb8--item",
  "item-image": "x9bf38834--8e1eb8--item-image",
  "item-title": "x9bf38834--8e1eb8--item-title",
  "item-description": "x9bf38834--8e1eb8--item-description",
  "tablet": "x9bf38834--8e1eb8--tablet",
  "phone": "x9bf38834--8e1eb8--phone",
};

module.exports = exports;
